import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ServiceAmazonRedirect() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect 308 vers /services#ads
    navigate('/services#ads', { replace: true });
  }, [navigate]);
  
  return null;
}